import Vue from 'vue';
import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { GeneralPath } from 'frontend/types/courses';

interface GeneralPathState {
  generalPath: GeneralPath;
}

const generalPath: Module<GeneralPathState, RootState> = {
  namespaced: true,
  state: {} as GeneralPathState,
  getters: {},
  mutations: {
    setValue(state: GeneralPathState, value: GeneralPath): void {
      Vue.set(state, 'generalPath', value);
    },
  },
  actions: {},
};

export default generalPath;
